/**
 * PartnerProductsCtrl controller
 */
/**
 * PartnerProductsCtrl controller
 *
 * @class PartnerProductsCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:PartnerProductsCtrl
 */
/* @ngInject */
export default function PartnerProductsCtrl ($scope, $uibModal, PartnerProduct, PartnerProgram, pckg, authSvc) {
  var vm = this

  vm.hasAccess = function (access) {
    return authSvc.hasAccess(access)
  }

  vm.hasFlag = function (flag) {
    return authSvc.hasEnabledFlag(flag)
  }

  /**
   * Network
   *
   * @memberof mwApp/packages.controller:PartnerProductsCtrl
   * @type {models.Network}
   */
  vm.pckg = pckg
  const networkId = vm.pckg.id

  /**
   * Get Vod Sets from backend
   *
   * @memberof mwApp/packages.controller:ContentSetsCtrl
   * @param {Object} tableState - smart table state object
   */
  vm.getPartnerProducts = function (tableState) {
    // set default sort by name
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'name'
      tableState.sort.reverse = false
    }

    PartnerProduct.loadSmart(tableState, { networkId })
      .then(
        data => {
          vm.partnerProducts = data.content.map(c => (new PartnerProduct({ ...c, networkId })))
          vm.issFound = !!vm.partnerProducts.length
          vm.tableState = tableState
          $scope.loading = false
        }
      )
  }

  PartnerProgram.loadAll().then((res) => {
    vm.partnerPrograms = res
    if (window.localStorage.getItem('partnerProductId')) {
      const id = window.localStorage.getItem('partnerProductId')
      window.localStorage.removeItem('partnerProductId')
      vm.editPP({ id, networkId })
    }
  })

  /**
   * Create partner program
   *
   * @memberof mwApp/partnerProducts.controller:PartnerProductsCtrl
   * @function
   * @param  {models.PartnerProduct} pp
   */
  vm.addPP = vm.editPP = function (pp) {
    var isNew = !pp
    var initialPP = angular.copy(pp) // initial state
    $uibModal.open({
      templateUrl: 'components/packages/views/addPartnerProduct.html',
      controller: 'AddPartnerProductCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        pp: function () {
          return !isNew
            ? PartnerProduct.load(pp)
            : new PartnerProduct({ networkId })
        },
        partnerPrograms: function () {
          return vm.partnerPrograms
        }
      }
    }).result
      .then(
        function close () {
          $scope.$broadcast('refreshTable')
        },
        function dismiss () {
          if (!isNew) {
            angular.copy(initialPP, pp) // restore catchup
          }
        }
      )
  }

  /**
   * Delete Partner Program
   *
   * @memberof mwApp/partnerProducts.controller:PartnerProductsCtrl
   */
  vm.delete = function (product) {
    product._delete()
      .then(() => vm.getPartnerProducts(vm.tableState))
  }
}
